import {createSignal} from '@pexip/signal';

export const mobileGetStartedNextSignal = createSignal({
    name: 'mobileGetStartedNextSignal',
});

export const renderCustomStepSignal = createSignal<boolean>({
    name: 'shouldRender:CustomStepPage',
});
